import { ComponentStyleConfig } from '@chakra-ui/react'

export const ContainerStyles: ComponentStyleConfig = {
    baseStyle: {
        padding: 0
    }
}
